import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Observable} from 'rxjs/index';
import {Action, Store} from '@ngrx/store';
import {CountiesService} from '../services/countiesServices/counties.service';
import {AppState} from '../reducers';
import * as CountyActions from '../actions/CountyActions';
import {map, mergeMap} from 'rxjs';

@Injectable()
export class CountyEffects {
  update$: Observable<Action> = createEffect(() => this.action$.pipe(
    ofType(CountyActions.RetrieveCountiesAction),
    mergeMap(action =>
      this.countiesService.retrieveCounties(action.year.year, action.state.federalStateNumber)
        .pipe(
          map(counties => CountyActions.CountiesReceivedAction({counties}))),
    ))
  );

  constructor(private countiesService: CountiesService,
              private action$: Actions, private store: Store<AppState>) {
  }
}
